export const ListingsRoutes = {
    path: 'listings',
    explain: {
        path: 'explain',
    },
    tutorial: {
        path: 'tutorial',
        config: {
            path: 'config',
        },
    },
    details: {
        path: ':listingId',
    },
};
